export default __webpack_public_path__ + "./images/ca.668ef6ac.png";